import { usePermissions } from "../Context/PermissionContext";
import { usePagesContent } from "./usePagesContent";
import { FEATURE_CODES } from "../Static/FeatureMapping";

// Org-level feature flag that enables the Platform/Smart Alerts module in
// Digital Twin (same flag used by alertTabsConfig).
export const PLATFORM_ALERTS_FEATURE = "DigitalTwin.Alerts.PlatformAlerts";

/**
 * Whether the current user can see Platform (Smart) Alerts surfaces.
 *
 * Gated on BOTH:
 *   1. the org feature flag (enabledFeatures includes PLATFORM_ALERTS_FEATURE), and
 *   2. RBAC v2 being enabled AND the PLATFORM_ALERTS_V2 view permission granted.
 *
 * hasPermission() returns true by default when RBAC v2 is off (V1 fallback), so
 * isRbacV2Enabled() is required to avoid granting access to RBAC-v2-off orgs.
 *
 * @returns {boolean}
 */
export function usePlatformAlertsAccess() {
    const { hasPermission, isRbacV2Enabled } = usePermissions();
    const pageContent = usePagesContent();

    const enabledFeatures = pageContent?.metaInfo?.enabledFeatures || [];
    const isFeatureEnabled = enabledFeatures.includes(PLATFORM_ALERTS_FEATURE);
    const hasV2Permission =
        isRbacV2Enabled() && hasPermission(FEATURE_CODES.PLATFORM_ALERTS_V2, "view");

    return isFeatureEnabled && hasV2Permission;
}
